import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const OrderSubmittedEventPayloadSchema = order.orderService.versions.v1.schemas.ORDER_SUBMITTED;

export type OrderSubmittedEventPayload = z.infer<typeof OrderSubmittedEventPayloadSchema>;
